import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { LocationSelectorTreeViewComponent } from './location-selector-tree-view/location-selector-tree-view.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocationSelectorComponent } from './location-selector.component';

@NgModule({
  declarations: [
    LocationSelectorTreeViewComponent,
    LocationSelectorComponent],
  imports: [
    CommonModule,
    TreeViewModule,
    TranslateModule
   
  ],
  exports:[
    LocationSelectorComponent,
    TranslateModule
  ]
})
export class LocationSelectorModule { }
